const hipermediaMedia = [...document.querySelectorAll('main img, main video')];

if ('IntersectionObserver' in window && hipermediaMedia.length) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('hm-media--color', entry.isIntersecting && entry.intersectionRatio >= 0.42);
      });
    },
    { threshold: [0, 0.42, 0.7] }
  );

  hipermediaMedia.forEach((media) => observer.observe(media));
}
